export const isWebpFile = (file) =>
  Boolean(file) &&
  (
    [
      "image/webp",
      "image/png",
      "image/jpeg",
    ].includes(file.type) ||
    [".webp", ".png", ".jpg", ".jpeg"].some((ext) =>
      file.name?.toLowerCase().endsWith(ext)
    )
  );

export const getWebpFileError = (file) => {
  if (!file) return "";
  return isWebpFile(file)
    ? ""
    : "Only WebP, PNG, JPG, and JPEG image files are allowed";
};
